import { render } from "./DevotionalCard.vue?vue&type=template&id=47930831&scoped=true"
import script from "./DevotionalCard.vue?vue&type=script&lang=js"
export * from "./DevotionalCard.vue?vue&type=script&lang=js"

import "./DevotionalCard.vue?vue&type=style&index=0&id=47930831&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47930831"]])

export default __exports__